import React from 'react';
import { StyledButton } from './Button.styles';
import { Spinner } from 'components/elements/spinner/Spinner';

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isFull?: boolean;
  isLoading?: boolean;
  variant?: 'primary' | 'outline' | 'transparent' | 'link';
  fontSize?: string;
}

export const Button: React.FC<ButtonProps> = ({
  children,
  ...props
}: ButtonProps) => {
  return (
    <StyledButton {...props}>
      {children}
      {props.isLoading && <Spinner variant='secondary' />}
    </StyledButton>
  );
};
